export default __webpack_public_path__ + "static/media/background-img.b27ef8b9.png";